// Navbar.js
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingCart } from "lucide-react";

const Navbar = ({ user, onLogout, cartCount }) => {
  const navigate = useNavigate();

  const handleProductosClick = (e) => {
    e.preventDefault();
    if (window.location.pathname === "/") {
      const section = document.getElementById("all-products-section");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const section = document.getElementById("all-products-section");
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  return (
    <nav className="bg-white shadow-md py-4 px-6">
      {/* Contenedor principal: justifica contenido entre el bloque de enlaces y el bloque de sesión/carrito */}
      <div className="flex justify-between items-center">
        {/* Bloque Izquierdo: Título + enlaces */}
        <div className="flex items-center space-x-6">
          <Link to="/" className="text-xl font-bold">
            Tienda <span className="text-blue-600">Kiwa</span>
          </Link>
          <Link to="/" className="text-gray-700 hover:text-blue-600">
            Inicio
          </Link>
          <a
            href="#all-products-section"
            onClick={handleProductosClick}
            className="text-gray-700 hover:text-blue-600"
          >
            Productos
          </a>
          <Link to="/about" className="text-gray-700 hover:text-blue-600">
            Sobre Nosotros
          </Link>
          {user && user.isAdmin && (
            <Link to="/admin" className="text-gray-700 hover:text-blue-600">
              Admin
            </Link>
          )}
        </div>

        {/* Bloque Derecho: Carrito, saludo y autenticación */}
        <div className="flex items-center space-x-4">
          {/* Carrito */}
          <Link to="/cart" className="relative">
            <ShoppingCart size={24} />
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold w-5 h-5 flex items-center justify-center">
                {cartCount}
              </span>
            )}
          </Link>

          {/* Saludo y sesión */}
          {user ? (
            <>
              <span className="text-gray-700">
                ¡Hola {user.name}! <span role="img" aria-label="saludo">👋</span>
              </span>
              <button onClick={onLogout} className="bg-red-500 text-white px-3 py-1 rounded">
                Cerrar sesión
              </button>
            </>
          ) : (
            <div className="flex space-x-4">
              <Link to="/login" className="text-gray-700 hover:text-blue-600">
                Iniciar Sesión
              </Link>
              <Link to="/register" className="text-gray-700 hover:text-blue-600">
                Registrarse
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
